import { Link, useLocation } from "react-router-dom";
import { Leaf } from "lucide-react";

export default function Logo({ small = false, dark = true, asLink = true }) {
  const inner = (
    <span className={`inline-flex items-center gap-2 font-display tracking-tight ${small ? "text-base" : "text-lg"}`}>
      <span className={`flex items-center justify-center w-8 h-8 rounded-md ${dark ? "bg-[#1A2F24] text-white" : "bg-white text-[#1A2F24]"}`}>
        <Leaf size={18} strokeWidth={2.2} />
      </span>
      <span className={`font-bold ${dark ? "text-[#1A2F24]" : "text-white"}`}>BaugrundCheck<span className="text-[#C05A44]">.de</span></span>
    </span>
  );
  if (asLink) return <Link to="/" data-testid="brand-logo" className="hover:opacity-80 transition-opacity">{inner}</Link>;
  return inner;
}
